export default __webpack_public_path__ + "static/media/travel2.4432797a.png";